import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IAssignmentPlan } from '@api/types'
import { AssignmentPlanFragment } from '@api/fragments'

interface IPayload {
  data: {
    viewer: {
      company: {
        primaryAssignmentPlan: IAssignmentPlan
      }
    }
  }
}

export default function primary(): Promise<IAssignmentPlan> {
  return client.gql.query({ query }).then(
    ({
      data: {
        viewer: {
          company: { primaryAssignmentPlan },
        },
      },
    }: IPayload) => primaryAssignmentPlan
  )
}

const query = gql`
  query PrimaryPlan {
    viewer {
      company {
        primaryAssignmentPlan {
          ...AssignmentPlanFragment
        }
      }
    }
  }
  ${AssignmentPlanFragment}
`
